import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";
import VideoController from "./video_controller";

const application = Application.start();
const controllers = import.meta.glob("./**/*_controller.js", { eager: true });

registerControllers(application, controllers);
application.register("video", VideoController);
